import PropertySelect from './PropertySelect';

export default PropertySelect;
